import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect, useCallback } from 'react';
import style from './style.module.scss';
export default function SummaryItem({ label, shortLabel, info, value, neg, pos }) {
    const [showTip, setShowTip] = useState(false);
    const tipRef = useRef(null);
    const btnRef = useRef(null);
    const itemRef = useRef(null);
    useEffect(() => {
        if (!showTip)
            return;
        const onDown = (e) => {
            if (tipRef.current?.contains(e.target))
                return;
            if (btnRef.current?.contains(e.target))
                return;
            setShowTip(false);
        };
        document.addEventListener('mousedown', onDown);
        return () => document.removeEventListener('mousedown', onDown);
    }, [showTip]);
    const adjustTip = useCallback((el) => {
        tipRef.current = el;
        if (!el || !itemRef.current)
            return;
        const itemRect = itemRef.current.getBoundingClientRect();
        const vw = document.documentElement.clientWidth;
        const margin = 12;
        // reset to measure natural width
        el.style.left = '0';
        el.style.right = 'auto';
        const tipW = el.offsetWidth;
        // desired left = align with item left edge (left: 0 in absolute = itemRect.left)
        let left = 0; // relative to item
        const absLeft = itemRect.left + left;
        const absRight = absLeft + tipW;
        if (absRight > vw - margin) {
            // shift left so it fits
            left = (vw - margin) - tipW - itemRect.left;
        }
        if (itemRect.left + left < margin) {
            // don't go past left edge
            left = margin - itemRect.left;
        }
        el.style.left = `${left}px`;
        el.style.right = 'auto';
    }, []);
    const valueClass = [style.value, neg ? style.neg : '', pos ? style.pos : ''].filter(Boolean).join(' ');
    return (_jsxs("div", { ref: itemRef, className: style['summary-item'], children: [_jsxs("div", { className: style['label-row'], children: [shortLabel ? (_jsxs(_Fragment, { children: [_jsx("span", { className: style['full-label'], children: label }), _jsx("span", { className: style['short-label'], children: shortLabel })] })) : (_jsx("span", { children: label })), info && (_jsx("button", { ref: btnRef, className: style['info-btn'], onClick: () => setShowTip(v => !v), "aria-label": "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435", children: _jsxs("svg", { width: "12", height: "12", viewBox: "0 0 16 16", fill: "none", children: [_jsx("circle", { cx: "8", cy: "8", r: "7", stroke: "currentColor", strokeWidth: "1.5" }), _jsx("text", { x: "8", y: "12", textAnchor: "middle", fontSize: "10", fill: "currentColor", fontWeight: "600", children: "i" })] }) }))] }), _jsx("div", { className: valueClass, children: value }), showTip && info && (_jsx("div", { ref: adjustTip, className: style['info-tooltip'], children: info }))] }));
}
